<template>
  <section id="bugsreport" class="fill-height">
    <v-container
      style="height: inehit"
      class="fill-height px-7 px-md-5 justify-center"
    >
      <v-row justify="space-around" align="center">
        <v-col
          cols="12"
          sm="8"
          md="5"
          class="text-center"
          style="transition: all 0.3s ease-out"
        >
          <v-img
            :src="require('../assets/brand/logo1.png')"
            alt="PBXBerry brand"
            width="25vh"
            class="mx-auto"
            contain
          ></v-img>
          <!-- <h1 class="mt-7 mt-md-12 headline">Bienvenido</h1> -->
          <h5 class="mt-8 mb-6">
            Reporte de fallas
          </h5>

          <div>
            <ValidationObserver ref="obs" v-slot="{ passes }">
              <v-form @submit.prevent="passes(signup)">
                <ValidationProvider
                  name="nombre y apellido"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-text-field
                    required
                    filled
                    rounded
                    label="Nombre y apellido"
                    name="firstname"
                    type="text"
                    color="secondary"
                    v-model="userData.name"
                    :error-messages="errors"
                  ></v-text-field>
                </ValidationProvider>

                <ValidationProvider
                  name="correo electrónico"
                  rules="email|required"
                  v-slot="{ errors }"
                >
                  <v-text-field
                    required
                    filled
                    rounded
                    label="Correo electrónico"
                    name="email"
                    type="text"
                    color="secondary"
                    v-model="userData.email"
                    :error-messages="errors"
                  ></v-text-field>
                </ValidationProvider>

                <ValidationProvider
                  name="asunto"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-select
                    filled
                    rounded
                    required
                    :items="items"
                    label="Asunto"
                    :error-messages="errors"
                    v-model="userData.subject"
                  ></v-select>
                </ValidationProvider>

                <ValidationProvider
                  name="descripción"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-textarea
                    required
                    filled
                    rounded
                    label="Descripción"
                    name="description"
                    color="secondary"
                    v-model="userData.description"
                    :error-messages="errors"
                  ></v-textarea>
                </ValidationProvider>

                <v-btn
                  rounded
                  dark
                  block
                  x-large
                  type="submit"
                  class="btn-primary-shadow"
                  color="primary"
                  :loading="isLoading"
                >
                  Enviar
                </v-btn>
              </v-form>
            </ValidationObserver>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
import { load } from "recaptcha-v3";

export default {
  name: "SignUp",

  data() {
    return {
      isLoading: false,
      items: [
        "Falla técnica",
        "Instalación",
        "Configuración",
        "Cotización",
        "Administración o Facturación",
        "Otro",
      ],
      userData: {
        name: "",
        email: "",
        subject: "",
        description: "",
      },
    };
  },

  methods: {
    // FUNCION CORRECTA (VERIFICACION DE DATOS)
    async signup() {
      try {
        this.isLoading = true;
        const recaptcha = await load(
          "6Ldy7qsUAAAAAMtsyrpPNWJ8p6Z4YLVZ7jFIdPX0"
        );
        const token = await recaptcha.execute("login");
        // console.log(token);
        // alert('submit!');
        const res = await this.$store.dispatch("passport/BUGREPORT", {
          name: this.userData.name,
          email: this.userData.email,
          subject: this.userData.subject,
          description: this.userData.description,
        });

        this.isLoading = false;
        this.$snotify.success("Se ha suscrito a PBXBerry.", "¡Genial!");
      } catch (error) {
        this.isLoading = false;
        this.$snotify.error(error.response.data.message, "¡Error!");
      }
    },
  },
};
</script>
